module.exports = __webpack_public_path__ + "img/rollingCastle.8fa75ad0.gif";